
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/payment",
      function () {
        return require("private-next-pages/d/account/payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/payment"])
      });
    }
  